import { Component } from "@angular/core";
import { Platform } from '@ionic/angular';
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { Router } from '@angular/router';
import { FcmService } from './services/fcm.service';
import { HttpClient } from '@angular/common/http';
import { Plugins } from '@capacitor/core';
import { AlertController } from '@ionic/angular';
const { App } = Plugins;


@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {

  public onlineOffline: boolean;
  appUpdateInfo: any;
  version: any;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public router: Router,
    public fcmService: FcmService,
    private http: HttpClient,
    public alertController: AlertController,
  ) {
    this.initializeApp();
    this.onlineOffline = navigator.onLine;
    window.addEventListener('offline', () => {
      //Do task when no internet connection
      this.onlineOffline = false;
      this.router.navigateByUrl('/tabs');

    });
    window.addEventListener('online', () => {
      //Do task when internet connection returns
      this.onlineOffline = true;
    });

    //close App
    this.platform.backButton.subscribeWithPriority(0, () => {
      if (this.router.url === "/tabs/home" || this.router.url === "/tabs/cart" ||this.router.url === "/tabs/orders") {
        this.presentAlert();
      }
    });
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert',
      subHeader: '',
      message: 'Do you want to close this App?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Yes',
          handler: () => {
            App.exitApp();
          }
        }
      ]
    });

    await alert.present();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      //   this.statusBar.backgroundColorByHexString("#FFCC2A");
      this.splashScreen.hide();
      this.statusBar.hide();

      // Trigger the push setup 
      this.fcmService.initPush();

      // let status bar overlay webview
      this.statusBar.overlaysWebView(true);

      // set status bar to white
      this.statusBar.backgroundColorByHexString("#ffffff");

      
    });
  }
}
